export default "__VITE_ASSET__OUkrqSfL__"